import type {
  SiteRequest,
  SiteRequestEvent,
  SiteRequestPrefill,
  SiteRequestStatus,
  SiteSettings,
} from "@shared/modules/x-site";
import { api } from "../../../core/lib/api";

const BASE = "/api/site/admin";

export interface SiteSettingsResponse {
  settings: SiteSettings;
  siteOrigin: string;
  stripeConfigured: boolean;
  readiness: {
    bookableServices: number;
    missingDurations: number;
    techniciansWithHours: number;
    techniciansWithoutHours: number;
    imported: boolean;
  };
}

export const getSettings = () => api<SiteSettingsResponse>(`${BASE}/settings`);
export const updateSettings = (input: Partial<SiteSettings>) =>
  api<SiteSettingsResponse>(`${BASE}/settings`, { method: "PUT", body: JSON.stringify(input) });

// ---- Demandes reçues du site ----

export type RequestFilter =
  "actives" | "a_traiter" | "en_cours" | "traitees" | "archivees" | "toutes";

export interface RequestList {
  requests: SiteRequest[];
  counts: Record<SiteRequestStatus, number>;
}

const query = (params: Record<string, string | undefined>) => {
  const search = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v) search.set(k, v);
  const s = search.toString();
  return s ? `?${s}` : "";
};

export const listRequests = (statut: RequestFilter, q?: string) =>
  api<RequestList>(`${BASE}/requests${query({ statut, q })}`);
export const getRequestHistory = (id: string) =>
  api<SiteRequestEvent[]>(`${BASE}/requests/${id}/history`);
export const updateRequest = (
  id: string,
  patch: { status?: SiteRequestStatus; assignedTo?: string | null; note?: string },
) => api<SiteRequest>(`${BASE}/requests/${id}`, { method: "PATCH", body: JSON.stringify(patch) });
export const deleteRequest = (id: string) =>
  api<void>(`${BASE}/requests/${id}`, { method: "DELETE" });
export const getRequestPrefill = (id: string) =>
  api<SiteRequestPrefill>(`${BASE}/requests/${id}/prefill`);
